<template>
  <div class="customer-table">
    <b-overlay :show="gettingCustomers" rounded opacity="0.6" spinner-small>
      <AutoComplete
        :disabled="disabledCustomer"
        v-model="selectedCustomer"
        :suggestions="filteredCustomers"
        :title="
          selectedCustomer ? selectedCustomer.name : 'Not selected customer'
        "
        field="name"
        placeholder="Search customer..."
        @complete="searchCustomers"
        @item-select="updateCustomerTable($event)"
        @stopSpinner="stopSpinner"
      />
      <br />
      <span v-if="thereIsCustomers" class="not-found">Customer not found.</span>
    </b-overlay>
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
import { disableByAssigned } from "@/mixins/infoEmail/validateQuote";

export default {
  name: "CustomerTable",
  props: {
    infoCustomer: Object,
    rowInfo: Object,
    infoUsername: String
  },
  components: {
    AutoComplete
  },
  data() {
    return {
      haulInformation: null,
      selectedCustomer: null,
      thereIsCustomers: false,
      filteredCustomers: null,
      customerName: null,
      customer: null,
      gettingCustomers: true,
      disabledCustomer: null
    };
  },
  watch: {
    selectedCustomer() {
      if (this.selectedCustomer == "" || this.selectedCustomer == null) {
        setTimeout(
          function() {
            this.thereIsCustomers = false;
          }.bind(this),
          700
        );
      }
    }
  },
  async created() {
    if (this.infoCustomer) {
      this.selectedCustomer = this.infoCustomer.name;
    }
    this.stopSpinner();
    this.disabledCustomer = disableByAssigned(
      this.rowInfo,
      this.infoUsername,
      this.$route.path
    );
  },
  methods: {
    async searchCustomers() {
      if (this.selectedCustomer !== "" && this.selectedCustomer !== null) {
        this.thereIsCustomers = false;
        let response = await this.$store.dispatch(
          "quotes/quote/getDataCustomers",
          this.selectedCustomer
        );
        this.filteredCustomers = response.data;
        if (response && response.data.length === 0) {
          this.thereIsCustomers = true;
        } else {
          this.thereIsCustomers = false;
        }
      } else {
        this.thereIsCustomers = false;
      }
      this.customerName = this.selectedCustomer.name;
    },
    async updateCustomerTable(event) {
      await this.getHaulInformation();
      for (let i in this.haulInformation) {
        let info = {};
        info.haulId = this.haulInformation[i].haul_id;
        info.payload = {};
        info.payload.customer_id = event.value.id;
        this.customer = event.value.id;
        this.$store.dispatch("quotes/haul/updateHaul", info);
      }
    },
    async getHaulInformation() {
      let response = await this.$store.dispatch(
        "quotes/quote/getHaulId",
        this.rowInfo.id
      );
      this.haulInformation = response.data;
    },
    stopSpinner() {
      this.gettingCustomers = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.not-found {
  display: flex;
  justify-content: center;
  color: red;
}
</style>
